// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_3s-1";
export var movingGradient = "_3s-4";
export var movingGradientBlock = "_3s-2";
export var skeleton = "_3s-0";
export var skeletonText = "_3s-3";